type Action = {
  type: string;
  typingUsers?: string[];
};

export default (state: string[] = [], action: Action): string[] => {
  switch (action.type) {
    case 'SERVER_TO_API[BROADCAST]:typing':
      return Array.isArray(action.typingUsers) ? action.typingUsers : state;
  }
  return state;
};
